import React from "react";
import { IonCard, IonCardContent, IonTitle } from "@ionic/react";

export const EnvCard = () => {

  return (
    <IonCard>
      <IonCardContent className="p-0">
        <IonTitle>Environment</IonTitle>
        <ul className="">
          {
            Object.entries(process.env).filter((entry) => (entry[0].startsWith("REACT"))).map((entry, idx) => (
              <li key={idx} className="px-2 py-2">
                <dl className="flex">
                  <dt className="flex-1 flex">{entry[0]}</dt>
                  <dd className="flex-shrink-0">{entry[1]}</dd>
                </dl>
              </li>
            ))
          }
        </ul>
      </IonCardContent>
    </IonCard>
  );
};
